(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
// Candidate only. Keep native constraint validation and Shopify submission intact.
const boundForms = new WeakSet();

function bindEmailFeedback(form) {
  if (boundForms.has(form)) return;
  const email = form.querySelector('input[type="email"][name="contact[email]"]');
  const message = form.querySelector('[data-ltl-email-error]');
  if (!email || !message?.id) return;
  boundForms.add(form);

  let active = false;
  let priorInvalid = null;
  const descriptions = () => (email.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);

  function clear() {
    if (!active) return;
    active = false;
    message.hidden = true;
    message.textContent = '';
    const remaining = descriptions().filter((id) => id !== message.id);
    if (remaining.length) email.setAttribute('aria-describedby', remaining.join(' '));
    else email.removeAttribute('aria-describedby');
    if (priorInvalid === null) email.removeAttribute('aria-invalid');
    else email.setAttribute('aria-invalid', priorInvalid);
  }

  function show() {
    if (email.validity.valid || (!email.validity.valueMissing && !email.validity.typeMismatch)) {
      clear();
      return;
    }
    if (!active) priorInvalid = email.getAttribute('aria-invalid');
    active = true;
    const text = email.validity.valueMissing ? message.dataset.required : message.dataset.invalid;
    if (message.textContent !== text) message.textContent = text;
    message.hidden = false;
    email.setAttribute('aria-invalid', 'true');
    email.setAttribute('aria-describedby', [...new Set([...descriptions(), message.id])].join(' '));
  }

  email.addEventListener('invalid', show);
  email.addEventListener('input', () => { if (active) show(); });
  email.addEventListener('change', () => { if (active) show(); });
  form.addEventListener('reset', clear);
}

function initialize(root = document) {
  root.querySelectorAll('form.contact-form__form').forEach(bindEmailFeedback);
}

if (typeof document !== 'undefined') {
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
}
})();
  } catch(e) { console.error(e); }
})();

})();
